import {
  AfterContentInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChange,
} from '@angular/core';

import { CurrencyPipe } from '@angular/common';
import { debounceFn } from 'src/shared/decorators/debounce-function.decorator';

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[punchPicker]' })
export class PunchPickerDirective
  implements OnInit, AfterContentInit, OnChanges
{
  @Output() items: EventEmitter<any> = new EventEmitter();
  @Input() maxValue = 9999999;
  @Input() minValue: number;
  @Input() sentValue: number;
  @Input() isPrice = false;
  @Input() isPercentage = false;
  @Input() isTitles = false;
  @Input() class = 'titulos';
  @Input() stepsIncrement = 10;
  @Input() placeholder = 'Títulos';

  private itemCounter = 0;
  private mouseAction: any;
  private titlesContainer: any;
  private isPressed = false;
  private SPEED = 200;
  private wasClicked = false;
  private previousValue: number;
  private currentValue: any;
  private mouseDown = false;

  constructor(public el: ElementRef, public renderer: Renderer2) {}

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    let value;
    if (!this.wasClicked) {
      if (this.titlesContainer === undefined) {
        return;
      }
      if (changes.sentValue !== undefined) {
        this.previousValue =
          changes.sentValue.previousValue !== undefined
            ? changes.sentValue.previousValue
            : undefined;
        value =
          changes.sentValue.currentValue !== undefined
            ? changes.sentValue.currentValue
            : undefined;
        changes.sentValue.previousValue =
          changes.sentValue.previousValue === undefined
            ? 0
            : changes.sentValue.previousValue;
        if (isNaN(changes.sentValue.previousValue)) {
          value = NaN;
        }
      }
      if (this.isPrice && value !== undefined) {
        value = !isNaN(value) ? value : 0;
        this.titlesContainer.value = this.formatNumber(
          value,
          value <= 1 ? true : false,
        );
      } else if (!this.isPrice && value !== undefined) {
        value = !isNaN(value) ? value : '';
        this.titlesContainer.value = this.formatNumberInt(value, true);
      }
      if (value !== undefined) {
        if (this.isPrice) {
          // this.itemCounter = this.formatNumber(value, value <= 1 ? true : false);
          this.itemCounter = this.cleanNumber(value);
          this.titlesContainer.value = '$' + this.titlesContainer.value;
        } else {
          // TODO: check if this is necessary
          value = value !== '' ? value : 0;
          this.itemCounter = parseInt(value !== '' ? value : 0, 10);
        }
      }
    } else {
      this.wasClicked = false;
    }
  }

  ngAfterContentInit() {
    this.fillPunchPicker();
  }

  setMaxValue() {
    this.itemCounter = this.maxValue;
    if (this.isPrice) {
      this.titlesContainer.value =
        '$' +
        this.formatNumber(
          this.itemCounter,
          this.itemCounter < 1 ? true : false,
        );
    } else if (this.isPercentage) {
      this.titlesContainer.value =
        this.formatNumberInt(this.itemCounter, false) + '%';
    } else {
      this.titlesContainer.value = this.formatNumberInt(
        this.itemCounter,
        false,
      );
    }
  }

  setMinValue() {
    this.itemCounter = this.minValue;
    if (this.isPrice) {
      this.titlesContainer.value =
        '$' +
        this.formatNumberInt(
          this.itemCounter,
          this.itemCounter < 1 ? true : false,
        );
    } else if (this.isPercentage) {
      this.titlesContainer.value =
        this.formatNumberInt(this.itemCounter, false) + '%';
    } else {
      this.titlesContainer.value = this.formatNumberInt(
        this.itemCounter,
        false,
      );
    }
  }

  cleanNumber(value: any): number {
    if (value === undefined) {
      return 0.0;
    }
    if (value.toString().indexOf(',') !== -1) {
      value = value.toString().replace(/\,/g, '');
    }
    if (value.toString().indexOf('$') !== -1) {
      value = value.toString().replace('$', '');
    }
    if (value.toString().indexOf('%') !== -1) {
      value = value.toString().replace('%', '');
    }

    return parseFloat(value);
  }

  formatNumber(value: number, menor: boolean): any {
    value = this.cleanNumber(value);
    if (menor) {
      return new CurrencyPipe('es-MX')
        .transform(value, 'MXN', 'symbol-narrow', '1.3-3')
        .substring(1);
    } else {
      return new CurrencyPipe('es-MX')
        .transform(value, 'MXN', 'symbol-narrow', '1.2-2')
        .substring(1);
    }
  }

  formatNumberInt(value: any, isOnChange: boolean = false) {
    if (value.length < 1 && isOnChange) {
      return '';
    }
    value = this.cleanNumber(value);
    const COMMAS = 3 || 3;
    const DECIMALS = '$';
    const regex = `\\d(?=(\\d{${COMMAS}})+${DECIMALS})`;

    return value.toFixed(0).replace(new RegExp(regex, 'g'), '$&,');
  }

  avoidDraggable(focusedElement: any) {
    focusedElement.cancelBubble = true;
    focusedElement.setAttribute('draggable', false);
  }

  addEventsToButtons(plus: any, minus: any) {
    plus.addEventListener('mouseleave', (event: any) => {
      if (this.isPressed) {
        this.isPressed = false;
        clearInterval(this.mouseAction);
      }
    });

    minus.addEventListener('mouseleave', (event: any) => {
      if (this.isPressed) {
        this.isPressed = false;
        clearInterval(this.mouseAction);
      }
    });
  }

  createElement(type: any, attribute: any, className: any) {
    const element: any = document.createElement(type);
    const atrkey = Object.keys(attribute)[0];
    const atrvalue = attribute[atrkey];

    element.setAttribute(atrkey, atrvalue);
    element.classList.add(className);

    return element;
  }

  attachClasses() {
    let auxClass;
    if (this.class !== undefined) {
      auxClass = this.class.split(' ');
      auxClass.map((value: any) => {
        this.el.nativeElement.classList.add(value);
      });
    }
  }

  fillPunchPicker() {
    let pickerType;

    const minus: any = this.createElement(
      'div',
      { 'data-type': 'minus' },
      'minus',
    );
    const plus: any = this.createElement(
      'div',
      { 'data-type': 'plus' },
      'plus',
    );
    const label: any = this.createElement(
      'label',
      { 'data-type': 'label' },
      'title',
    );
    const whatClass = this.isPrice ? 'order-price' : 'order-titles';
    const WAIT_TIME = 500;

    // label.innerHTML = this.placeholder;

    this.titlesContainer = this.createElement(
      'input',
      { type: 'text' },
      'titles-value',
    );
    this.titlesContainer.setAttribute('required', 'required');

    if (this.isPrice || this.isPercentage) {
      pickerType = this.isPrice ? 'price' : 'percentage';
      this.titlesContainer.classList.add(pickerType);
    }

    if (this.minValue !== undefined) {
      this.titlesContainer.value = this.minValue;
      this.itemCounter = this.minValue;
    }

    if (this.sentValue !== undefined) {
      this.titlesContainer.value = this.sentValue;
      this.itemCounter = this.sentValue;
    }
    if (this.minValue !== undefined || this.sentValue !== undefined) {
      setTimeout(() => {
        this.items.emit(this.itemCounter);
      }, WAIT_TIME);
    }
    this.el.nativeElement.appendChild(minus);
    this.el.nativeElement.appendChild(plus);
    this.el.nativeElement.appendChild(this.titlesContainer);
    this.el.nativeElement.appendChild(label);

    this.el.nativeElement.classList.add(whatClass);

    this.attachClasses();
    this.addEventsToButtons(plus, minus);

    this.avoidDraggable(plus);
    this.avoidDraggable(minus);
    this.avoidDraggable(this.el.nativeElement);
    this.avoidDraggable(label);
    this.avoidDraggable(this.titlesContainer);
  }

  ngOnInit() {
    this.el.nativeElement.classList.add('punch-picker');
  }

  getIncrement(counter: any) {
    if (this.isPrice && this.sentValue < 1) {
      return 0.01;
    } else if (this.isPrice && this.sentValue > 1) {
      return 1;
    } else {
      return 10;
    }
  }

  handlePlus() {
    let INCREMENT: any = 1;
    let counter = 0;

    this.mouseAction = setInterval(() => {
      this.mouseDown = true;
      INCREMENT = this.getIncrement(counter);
      this.itemCounter += INCREMENT;
      if (this.maxValue !== undefined && this.itemCounter >= this.maxValue) {
        this.itemCounter = this.maxValue;
      }
      if (this.isPrice) {
        this.titlesContainer.value =
          this.itemCounter < 1
            ? this.itemCounter.toFixed(3)
            : this.itemCounter.toFixed(2);
      } else {
        this.titlesContainer.value = this.itemCounter;
      }
      counter += this.SPEED;
    }, this.SPEED);
  }

  handleMinus() {
    let DECREMENT: any = 1;
    let counter = 0;

    this.mouseAction = setInterval(() => {
      this.mouseDown = true;
      DECREMENT = this.getIncrement(counter);
      this.itemCounter -= DECREMENT;
      if (this.itemCounter < 0) {
        this.itemCounter = 0;
      }
      if (this.minValue !== undefined && this.itemCounter <= this.minValue) {
        this.itemCounter = this.minValue;
      }
      if (this.isPrice) {
        this.titlesContainer.value =
          this.itemCounter < 1
            ? this.itemCounter.toFixed(3)
            : this.itemCounter.toFixed(2);
      } else {
        this.titlesContainer.value = this.itemCounter;
      }

      counter += this.SPEED;
    }, this.SPEED);
  }

  validateValue(value: any) {
    // this.titlesContainer.value = this.titlesContainer.value.replace('$', '');
    // this.titlesContainer.value = this.titlesContainer.value.replace('%', '');
    if (typeof value === 'string') {
      value = value.replace(/\$/g, '');
      value = value.replace(/\%/g, '');
    }

    if (this.maxValue !== undefined && value > this.maxValue) {
      return this.maxValue;
    } else if (this.minValue !== undefined && value < this.minValue) {
      return this.minValue;
    } else {
      return value;
    }
  }

  removeSigns(value: any): boolean {
    if (
      this.titlesContainer.value.indexOf('$') > -1 ||
      this.titlesContainer.value.indexOf('%') > -1
    ) {
      this.titlesContainer.value = this.titlesContainer.value.replace('$', '');
      this.titlesContainer.value = this.titlesContainer.value.replace('%', '');
      return true;
    }
    return false;
  }

  // getValue(event: any) {
  //   let value: any = this.titlesContainer.value;
  //   let auxValue: any;

  //   if (event.keyCode === 8) {
  //     if (typeof value === 'string') {
  //       value = value.replace(/\,/g, '');
  //     }
  //     auxValue = !isNaN(parseInt(value.substring(0, value.length - 1), 10)) ? parseInt(value.substring(0, value.length - 1), 10) : '';
  //     return this.validateValue(auxValue);
  //   } else if (!isNaN(parseInt(event.key, 10))) {
  //     auxValue = `${this.titlesContainer.value}${event.key}`;
  //     return this.validateValue(auxValue);
  //   } else {
  //     return this.validateValue(this.titlesContainer.value);
  //   }
  // }

  @HostListener('click', ['$event']) mouseClicked($event: any) {
    let tellIsEmpty = false;
    let clickedPlusOrMinus = false;

    if ($event.target.className === 'titles-value') {
      this.titlesContainer.setSelectionRange(
        0,
        this.itemCounter.toString().length + 5,
      );
    }

    if ($event.target.className === 'plus') {
      clickedPlusOrMinus = true;
      if (this.isPrice) {
        if (this.itemCounter >= 1) {
          this.itemCounter = !this.mouseDown
            ? this.itemCounter + 0.01
            : this.itemCounter;
        } else {
          if (this.itemCounter !== 0) {
            this.itemCounter = !this.mouseDown
              ? this.itemCounter + 0.001
              : this.itemCounter;
          } else {
            this.itemCounter = 0.01;
          }
        }
      } else {
        if (typeof this.stepsIncrement === 'string') {
          this.stepsIncrement = parseInt(this.stepsIncrement, 10);
        }
        this.itemCounter += this.stepsIncrement;
        this.previousValue = !isNaN(this.previousValue)
          ? this.previousValue + this.stepsIncrement
          : this.stepsIncrement;
        this.wasClicked = true;
      }
      if (this.maxValue !== undefined) {
        this.itemCounter =
          this.itemCounter <= this.maxValue ? this.itemCounter : this.maxValue;
        this.previousValue = this.itemCounter;
      }
    } else if ($event.target.className === 'minus') {
      clickedPlusOrMinus = true;
      if (this.isPrice) {
        if (this.itemCounter >= 1) {
          this.itemCounter = this.itemCounter - 0.01;
        } else {
          this.itemCounter = this.itemCounter - 0.001;
        }
      } else {
        this.itemCounter -= this.stepsIncrement;
        if (
          this.previousValue <= this.stepsIncrement ||
          isNaN(this.previousValue)
        ) {
          this.previousValue = 0;
        } else {
          this.previousValue = this.itemCounter;
        }
        this.wasClicked = true;
      }
      if (this.itemCounter < 0) {
        this.itemCounter = 0;
      }
      if (this.minValue !== undefined) {
        this.itemCounter =
          this.itemCounter >= this.minValue ? this.itemCounter : this.minValue;
        this.previousValue = this.itemCounter;
      }
    }
    if (!this.wasClicked) {
      tellIsEmpty = !isNaN(this.itemCounter) ? false : true;
      this.itemCounter = !isNaN(this.itemCounter) ? this.itemCounter : 0;
    } else if (this.mouseDown) {
      this.itemCounter = this.cleanNumber(this.titlesContainer.value);
      this.previousValue = this.itemCounter > 0 ? this.itemCounter : 0;
    } else {
      if (this.isPercentage || this.isTitles) {
        this.itemCounter =
          !isNaN(this.cleanNumber(this.titlesContainer.value)) &&
          !clickedPlusOrMinus
            ? this.cleanNumber(this.titlesContainer.value)
            : this.itemCounter;
      } else {
        this.itemCounter = !isNaN(this.previousValue) ? this.previousValue : 0;
      }
      tellIsEmpty = !isNaN(this.itemCounter) ? false : true;
    }

    this.mouseDown = false;

    if (this.isPrice) {
      // let start = this.titlesContainer.selectionStart;
      // if (this.removeSigns($event)) {
      // start = start !== 0 ? start - 1 : 0;
      // this.titlesContainer.setSelectionRange(start, start);
      // } else {
      if (clickedPlusOrMinus) {
        this.titlesContainer.value =
          '$' +
          this.formatNumber(
            this.itemCounter,
            this.itemCounter <= 1 ? true : false,
          );
      }
      // }
    } else if (this.isPercentage) {
      let start = this.titlesContainer.selectionStart;
      start = start !== 0 ? start : 0;
      this.titlesContainer.setSelectionRange(
        0,
        this.titlesContainer.value.toString().length + 5,
      );
      this.titlesContainer.value = this.formatNumberInt(this.itemCounter) + '%';
    } else if (this.isTitles) {
      if (!tellIsEmpty) {
        if (this.minValue !== undefined) {
          this.titlesContainer.value =
            this.itemCounter < this.minValue
              ? this.formatNumberInt(this.minValue)
              : this.formatNumberInt(this.itemCounter);
        } else {
          this.titlesContainer.value =
            this.itemCounter > 0 ? this.formatNumberInt(this.itemCounter) : '';
        }
      } else {
        this.titlesContainer.value = '';
      }
    } else {
      if (!tellIsEmpty) {
        this.titlesContainer.value = this.formatNumberInt(this.itemCounter);
      } else {
        this.titlesContainer.value = '';
      }
    }
    this.items.emit(this.itemCounter);

    // if (!this.itemCounter) {
    //   this.titlesContainer.setSelectionRange(0, 5);
    // }
  }

  @HostListener('mousedown', ['$event']) mouseHold($event: any) {
    $event.stopPropagation();
    this.isPressed = true;
    if ($event.target.className === 'plus') {
      this.handlePlus();
    } else if ($event.target.className === 'minus') {
      this.handleMinus();
    }
  }

  @HostListener('mouseup', ['$event']) mouseReleased($event: any) {
    $event.stopPropagation();
    this.isPressed = false;
    clearInterval(this.mouseAction);
    this.itemCounter = this.cleanNumber(this.itemCounter);
    this.items.emit(this.itemCounter);
    if (!this.isPercentage) {
      this.titlesContainer.setSelectionRange(
        0,
        this.itemCounter.toString().length + 5,
      );
    }
  }

  @HostListener('keyup', ['$event'])
  @debounceFn(500)
  blurUp($event: any) {
    let auxValue: any;
    if ($event.shiftKey) {
      return false;
    }
    if (
      $event.keyCode === 9 ||
      $event.keyCode === 110 ||
      $event.keyCode === 190 ||
      $event.keyCode === 37 ||
      $event.keyCode === 39 ||
      ($event.keyCode >= 95 && $event.keyCode <= 105)
    ) {
      if (this.isPrice) {
        this.itemCounter = this.cleanNumber($event.target.value);
      } else if (this.isPercentage) {
        auxValue = this.validateValue($event.target.value);
        this.itemCounter = parseInt(auxValue, 10);
      } else {
        auxValue = this.validateValue($event.target.value);
        this.itemCounter =
          typeof auxValue === 'string'
            ? parseInt(auxValue.replace(/\,/g, ''), 10)
            : auxValue;
        this.previousValue = this.itemCounter;
      }
      this.items.emit(this.itemCounter);
    } else {
      if ($event.keyCode > 31 && ($event.keyCode < 48 || $event.keyCode > 57)) {
        return false;
      } else {
        if (this.isPrice) {
          this.itemCounter = this.cleanNumber($event.target.value);
          // this.titlesContainer.value = !isNaN(this.cleanNumber(auxValue)) ? auxValue : '';
        } else if (this.isPercentage) {
          auxValue = this.validateValue($event.target.value);
          this.itemCounter = parseFloat(auxValue);
          // this.titlesContainer.value = !isNaN(this.cleanNumber(auxValue)) ? auxValue + '%' : '';
        } else {
          auxValue = this.validateValue($event.target.value);
          // this.titlesContainer.value = !isNaN(auxValue) ? auxValue : '';
          this.itemCounter =
            typeof auxValue === 'string'
              ? parseInt(auxValue.replace(/\,/g, ''), 10)
              : auxValue;
          this.previousValue = this.itemCounter;
        }
        if (this.titlesContainer.value.length < 1) {
          this.itemCounter = 0;
          this.items.emit('');
        } else {
          this.items.emit(this.itemCounter);
        }
      }
    }
  }

  @HostListener('keydown', ['$event']) keyTyped($event: any) {
    if ($event.shiftKey) {
      return false;
    }
    if (
      $event.keyCode === 110 ||
      $event.keyCode === 190 ||
      $event.keyCode === 37 ||
      $event.keyCode === 39 ||
      ($event.keyCode >= 95 && $event.keyCode <= 105)
    ) {
      // this.removeSigns($event);
      this.itemCounter = this.cleanNumber($event.target.value);
      // this.itemCounter = this.getValue($event);
    } else {
      if ($event.keyCode > 31 && ($event.keyCode < 48 || $event.keyCode > 57)) {
        return false;
      } else {
        // this.removeSigns($event);
        this.itemCounter = this.cleanNumber($event.target.value);
        // this.itemCounter = this.getValue($event);
      }
    }
  }

  @HostListener('focusout', ['$event.target']) focusout($event: any) {
    this.el.nativeElement.classList.remove('active');
    let auxValue: any;

    if (this.isPrice) {
      if (this.titlesContainer.value.length < 1) {
        this.items.emit('');
      } else {
        this.itemCounter = this.cleanNumber(this.titlesContainer.value);
        auxValue = this.formatNumber(
          this.itemCounter,
          this.itemCounter <= 1 ? true : false,
        );
        this.titlesContainer.value = !isNaN(this.cleanNumber(auxValue))
          ? '$' + auxValue
          : '';
        this.previousValue = this.cleanNumber(auxValue);
        this.items.emit(this.itemCounter);
      }
    } else if (this.isPercentage) {
      auxValue = this.formatNumberInt(this.titlesContainer.value);
      this.titlesContainer.value = !isNaN(this.cleanNumber(auxValue))
        ? auxValue + '%'
        : '';
    } else {
      if (
        this.minValue !== undefined &&
        this.titlesContainer.value < this.minValue
      ) {
        this.titlesContainer.value = this.minValue;
      }
      auxValue = this.formatNumberInt(this.titlesContainer.value);
      this.itemCounter = this.cleanNumber(auxValue);
      this.titlesContainer.value = !isNaN(this.cleanNumber(auxValue))
        ? auxValue
        : '';
      this.previousValue = this.cleanNumber(auxValue);
      this.items.emit(this.itemCounter);
    }

    if (this.itemCounter > this.maxValue) {
      this.setMaxValue();
    } else if (this.itemCounter < this.minValue) {
      this.setMinValue();
    }
  }

  @HostListener('focusin', ['$event.target']) focusin() {
    this.el.nativeElement.classList.add('active');
  }
}
